export default __webpack_public_path__ + "static/media/Futura-Medium.4e762c29.woff";